// Español (idioma por defecto)
export default {
  common: {
    confirm: 'Aceptar',
    submit: 'Aceptar',
    search: 'Buscar',
    loadMore: 'Cargar Más',
    loading: 'Cargando...',
    cancel: 'Cancelar',
    back: 'Volver',
    noData: 'Sin datos',
    copy: 'Copiar',
    copied: 'Copiado',
    copyFailed: 'Error al copiar',
  },
  lang: {
    label: 'Idioma',
    es: 'Español',
    zh: '中文',
    en: 'English',
  },
  tabbar: {
    home: 'INICIO',
    query: 'CONSULTA',
    info: 'INFORMACIÓN',
    my: 'Mi',
  },
  login: {
    user: 'Usuario',
    userPlaceholder: 'Ingrese teléfono de 8 dígitos',
    password: 'Contraseña',
    passwordPlaceholder: 'Contraseña',
    submit: 'INICIE SESIÓN',
    createAccount: 'CREAR CUENTA',
      userMustBe8Digits: 'La cuenta debe tener 8 dígitos',
},
  register: {
    user: 'Usuario',
    userPlaceholder: 'Ingrese teléfono de 8 dígitos',
    password: 'Contraseña',
    passwordPlaceholder: 'Contraseña',
    confirmPassword: 'Confirmar Contraseña',
    confirmPasswordPlaceholder: 'Confirmar Contraseña',
    confirmPasswordRequired: 'CONFIRMAR CONTRASEÑA',
    name: 'Nombre',
    namePlaceholder: 'Nombre',
    sinpe: 'SINPE Móvil',
    sinpePlaceholder: 'SINPE Móvil',
    sinpeRequired: 'Móvil',
    submit: 'REGÍSTRATE',
    submitting: 'Sumisión...',
    backToLogin: 'Volver a la página de inicio de sesión',
    passwordMismatch: 'Dos contraseñas son inconsistentes',
    success: 'Registro exitoso',
    fail: 'Registro fallido',
      userMustBe8Digits: 'La cuenta debe tener 8 dígitos',
},
  home: {
    noLottery: 'Actualmente no hay loterías',
    paga: 'PAGA',
    saldo: 'SALDO',
    monto: 'Monto',
    rMonto: 'RMonto',
    total: 'Total',
    reventados: 'REVENTADOS',
    colNum: 'Nú',
    colAmount: '₡',
    colReve: 'Reve',
    colSorteo: 'Sorteo',
    betList: 'Lista de apuestas',
    order: 'PEDIDO',
    orderSuccess: 'Pedido realizado con éxito',
    orderFail: 'Error al realizar el pedido',
    selectLottery: 'Seleccione lotería pedido',
    enterAmountRight: 'Introduce el importe a la derecha',
    selectNumAndAmount: 'Seleccione números de lotería y monto',
    selectNum: 'Seleccionar números de lotería',
    changeProductTitle: '¿Estás seguro de que quieres cambiar de producto?',
    changeProductMessage:
      'La lotería ha sido seleccionada actualmente. Si desea cambiar, se perderá la seleccionada anteriormente.',
    sorteo: 'Sorteo',
  },
  successOrder: {
    title: 'Imprimir',
    validFor: 'VALIDO SOLO PARA:',
    mobile: 'Móvil:',
    date: 'FECHA:',
    invoice: 'FACTURA:',
    paga: 'PAGA:',
    colNum: 'Nú',
    colAmount: '₡',
    colReve: 'Reve',
    total: 'TOTAL:',
    note1: '** TIENE 7 DIAS PARA COBRAR **',
    note2: '** REVISE ANTES DE PAGAR **',
    note3: '** NO SE ACEPTAN RECLAMOS **',
    note4: '** SIN TIQUETE NO HAY PAGO **',
    sellerSign: 'FIRMA VENDEDOR:__________________',
    thanks: 'Gracias por apostar',
    print: 'Imprimir',
      continueOrder: 'Seguir apostando',
    sendWhatsApp: 'Enviar por WhatsApp',
},
  order: {
    listTitle: 'Información del pedido',
    detailTitle: 'Detalles del pedido',
    status: 'Estado:',
    statusValid: 'Eficiente',
    orderNo: 'Número de orden:',
    colNum: 'Nú',
    colAmount: '₡',
    colReve: 'Reve',
  },
  query: {
    winningTab: 'Consulta Ganadora',
    rechargeTab: 'Consulta de Recarga',
    withdrawTab: 'Consulta de Retiro',
    startTime: 'Hora De Inicio',
    startTimePlaceholder: 'Haga clic para seleccionar la hora',
    endTime: 'Tiempo Final',
    endTimePlaceholder: 'Hora De Inicio',
    pickerTitle: 'Seleccione año, mes y día',
    time: 'Hora:',
    rechargeAmount: 'Monto de recarga:',
    withdrawAmount: 'Retirar monto:',
    sorteo: 'Sorteo:',
    lottery: 'Lotería:',
    number: 'Número:',
    amount: 'Monto:',
    pendingRecharges: 'Recargas pendientes',
  },
  my: {
    account: 'Cuenta:',
    balance: 'Saldo:',
    withdrawing: 'Retiro:',
    recharge: 'Recargá',
    withdraw: 'Retiro',
    changePassword: 'Cambiar la contraseña',
    messageCenter: 'Centro De Mensajes',
    logout: 'SALIR',
  },
  recharge: {
    title: 'Recargá',
    method: 'Método de transferencia',
    methodPlaceholder: 'Haga clic para seleccionar el método de recarga',
    methodRequired: 'Por favor seleccione el método de pago',
    amount: 'Monto a Recargá',
    amountPlaceholder: 'Por favor ingresa el monto a recargar',
    minAmount: 'El monto de la recarga debe ser mayor a 100',
      arrivedTitle: 'Recarga recibida',
    arrivedHint: 'Su cuenta ha recibido una recarga',
    newBalance: 'Saldo actual',
    sinpeNoticeTitle: 'Importante: Obligatorio',
    sinpeNoticeBody: 'Al transferir, es OBLIGATORIO escribir el número de teléfono de su cuenta en el campo "Descripción (opcional)" de SINPE Móvil. De lo contrario, el crédito no será automático y requerirá revisión manual, retrasando el proceso.',
    sinpeNoticeTail: 'Ejemplo: escriba su teléfono en la descripción ↑',
    paymentInfo: 'Información de pago',
    accountNo: 'Cuenta destino',
    yourMobile: 'Su teléfono',
    submittedTitle: 'Solicitud de recarga enviada',
    submittedHint: 'Abra su app bancaria para transferir. Puede volver aquí en cualquier momento para copiar los datos:',
    sinpeReminder: 'No olvide escribir su teléfono en el campo Descripción de SINPE, de lo contrario el crédito puede no ser automático',
    gotIt: 'Entendido',
    accountName: 'Destinatario',
    orderId: 'ID de pedido',
    pendingTitle: 'Recarga pendiente',
    viewInfo: 'Ver info',
  },
  withdraw: {
    title: 'Retiro',
    amount: 'Monto',
    amountPlaceholder: 'Por favor ingresa el monto que deseas retirar',
    minAmount: 'El monto del retiro debe ser mayor a 100 palabras.',
    success: 'La solicitud de retiro fue exitosa, por favor espere el SINPE',
      completedTitle: 'Retiro procesado',
    completedHint: 'Su solicitud de retiro ha sido procesada',
},
  message: {
    title: 'Centro De Mensajes',
    newMessage: 'Nuevo mensaje',
    newMessageText: 'Tienes un nuevo mensaje sobre: {title}',
  },
  changePassword: {
    title: 'Cambiar la contraseña',
    oldPassword: 'Contraseña anterior',
    oldPasswordPlaceholder: 'Por favor ingrese la contraseña anterior',
    password: 'Contraseña',
    passwordPlaceholder: 'Nueva contraseña',
    confirmPassword: 'Confirmar Contraseña',
    confirmPasswordPlaceholder: 'Nueva contraseña nuevamente',
    passwordMismatch: 'Las dos contraseñas son inconsistentes, vuelva a ingresar',
  },
  setting: {
    title: 'Configuración',
    changeAvatar: 'Cambiar imagen',
    changePassword: 'Cambiar la contraseña',
    changePrint: 'Cambiar parámetros de impresión',
    avatarTitle: 'Cambiar imagen',
    printTitle: 'Cambiar plantilla de impresión',
    selectFirst: 'Seleccione primero antes de enviar',
  },
  routeTitle: {
    Home: 'Inicio',
    Query: 'Consulta integral',
    Order: 'Información del pedido',
    OrderDetail: 'Detalles del pedido',
    My: 'Mi',
    Setting: 'Configuración',
    Avatar: 'Subir imagen',
    ChangePassword: 'Cambiar la contraseña',
    PrintTemplate: 'Cambiar plantilla de impresión',
    Recharge: 'Centro de recarga',
    Message: 'Centro de mensajes',
    Withdraw: 'Centro de retiro',
    SuccessOrder: 'Detalles del pedido',
    login: 'Iniciar sesión',
    register: 'Registrarse',
  },
};
